/**
 * Scan dates are real UTC from the API but are shown and edited in Netherlands time
 * (Europe/Amsterdam), whatever the admin's own time zone is.
 */

export const TIME_ZONE = 'Europe/Amsterdam';

const partsFormat = new Intl.DateTimeFormat('en-GB', {
  timeZone: TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
});

function wallParts(date) {
  const parts = Object.fromEntries(partsFormat.formatToParts(date).map((p) => [p.type, p.value]));
  return parts;
}

const toDate = (value) => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** ISO UTC → Amsterdam wall time for `<input type="datetime-local" step="1">`: "2026-10-07T08:38:01". */
export function toAmsterdamInput(iso) {
  const d = toDate(iso);
  if (!d) return '';
  const p = wallParts(d);
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}:${p.second}`;
}

/** Form value → what PATCH/PUT expect: "YYYY-MM-DDTHH:mm:ss", no offset (= Amsterdam time). */
export function toApiWallTime(input) {
  if (!input) return null;
  return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(input) ? `${input}:00` : input;
}

/** True when an Amsterdam wall time ("YYYY-MM-DDTHH:mm[:ss]") is later than now in Amsterdam. */
export function isFutureWallTime(input, now = new Date()) {
  const value = toApiWallTime(input);
  return Boolean(value) && value > toAmsterdamInput(now);
}

const timeFormat = new Intl.DateTimeFormat('en-GB', { timeZone: TIME_ZONE, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
const dateFormat = new Intl.DateTimeFormat('en-GB', { timeZone: TIME_ZONE, day: '2-digit', month: 'short', year: 'numeric' });

/** "Today, 14:38", "Yesterday, 08:14" or "09 Oct 2026, 08:14" in Amsterdam time; "—" without a date. */
export function formatAmsterdam(iso, now = new Date()) {
  const d = toDate(iso);
  if (!d) return '—';
  const day = toAmsterdamInput(d).slice(0, 10);
  const today = toAmsterdamInput(now).slice(0, 10);
  const yesterday = toAmsterdamInput(new Date(now.getTime() - 24 * 3600 * 1000)).slice(0, 10);
  const time = timeFormat.format(d);
  if (day === today) return `Today, ${time}`;
  if (day === yesterday) return `Yesterday, ${time}`;
  return `${dateFormat.format(d)}, ${time}`;
}
